import { render } from "./AppManage.vue?vue&type=template&id=c875a92e&scoped=true"
import script from "./AppManage.vue?vue&type=script&lang=js"
export * from "./AppManage.vue?vue&type=script&lang=js"

import "./AppManage.vue?vue&type=style&index=0&id=c875a92e&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c875a92e"]])

export default __exports__